import styled from 'styled-components';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import Avatar from '@mui/material/Avatar';
import { Colors } from '../../../theme';
import { fontRegular16, fontSemibold16 } from '../styles/fonts';
export const Wrapper = styled.section `
  display: flex;
  align-items: center;
`;
export const AvatarName = styled(Avatar) `
  &.MuiAvatar-root {
    margin-right: 8px;
    ${fontRegular16}
    color: ${Colors.blue60};
    background-color: ${Colors.blue10};
  }
`;
export const FullName = styled.div `
  ${fontSemibold16}
  color: ${Colors.black80};
`;
export const Container = styled.div `
  flex: 1;
`;
export const AccountWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const AccountLabel = styled.div `
  ${fontRegular16}
  color: ${Colors.black80};
`;
export const AccountId = styled.div `
  display: flex;
  align-items: center;
  ${fontRegular16}
  color: ${Colors.black80};
`;
export const CopyIcon = styled(FileCopyOutlinedIcon) `
  width: ${(props) => (props.$size === 'default' ? '22px' : '16px')};
  margin-left: 8px;
  font-size: 24px;
  cursor: pointer;
`;
//# sourceMappingURL=styles.js.map